module.exports = __webpack_public_path__ + "img/WRLD0090---SML_TAPONMOBILE_TRADERPORTAL_728x90.5a5ef182.gif";